import React from 'react';
import { Table } from '@myua/kit';
import { ColumnKey } from '../model';
import { getLoading, getSelectedIds, getColumns, getPagination, getLinks } from '../selectors';
import { useSelector, useDispatch } from 'react-redux';
import AutoSizer from 'react-virtualized-auto-sizer';
import * as sharingLinkActions from '../actions';
import { SharingLink } from '../../../api';

const HEADER_HEIGHT = 48;
const PAGINATION_HEIGHT = 64;

export const Links = () => {
  const dispatch = useDispatch();
  const links = useSelector(getLinks);
  const loading = useSelector(getLoading);
  const selectedIds = useSelector(getSelectedIds);
  const columns = useSelector(getColumns);
  const pagination = useSelector(getPagination);

  return (
    <div className="al-sharing-links">
      <AutoSizer>
        {({ width, height }) => {
          return (
            <div style={{ width }}>
              <Table
                rowKey={ColumnKey.id}
                columns={columns}
                dataSource={links}
                loading={loading}
                size="small"
                scroll={{ y: height - HEADER_HEIGHT - PAGINATION_HEIGHT }}
                pagination={{
                  ...pagination,
                  size: 'default',
                  showSizeChanger: false,
                }}
                showSorterTooltip={false}
                rowSelection={{
                  selectedRowKeys: selectedIds,
                  onChange: (ids) =>
                    dispatch(sharingLinkActions.linksSelected({ ids: ids as SharingLink['id'][] })),
                }}
                onChange={(pagination, filters, sorter, extra) => {
                  if (extra.action === 'sort') {
                    if (!Array.isArray(sorter)) {
                      dispatch(
                        sharingLinkActions.sorterChanged({
                          columnKey: sorter.columnKey,
                          order: sorter.order,
                        }),
                      );
                    }
                  } else if (extra.action === 'filter') {
                    // Фильтр Active серверный: выбранное значение уходит в стор →
                    // is_active в API, пагинация/total считаются на бэке (MYUA-16466).
                    const value = filters[ColumnKey.is_active]?.[0];
                    dispatch(
                      sharingLinkActions.isActiveFilterChanged({
                        isActive: typeof value === 'boolean' ? value : undefined,
                      }),
                    );
                  } else if (extra.action === 'paginate') {
                    dispatch(
                      sharingLinkActions.paginationChanged({ current: pagination.current ?? 1 }),
                    );
                  }
                }}
              />
            </div>
          );
        }}
      </AutoSizer>
    </div>
  );
};
